import React, { useEffect, useState } from 'react'
import { PieChart } from 'react-minimal-pie-chart'
import { AdminEmployeeLeaveInfo } from '../../Repository/Api'
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
const LeaveInfo = (profile) => {
    const state = useSelector((state) => state);
    const token = state?.auth?.auth?.access_token;
    const [count, setCount] = useState({})
    const { id } = useParams()
    
    const datacasual = [
        { title: "One", value: count?.casual_leave_balance, color: "#A3AED0" },
        {
            title: "Two",
            value: count?.casual_leave_current_year_taken,
            color: "#33A3F4",
        },
    ];
    const dataearned = [
        {
            title: "One",
            value: count?.earned_leave_balance,
            color: "#A3AED0",
        },
        {
            title: "Two",
            value: count?.earned_leave_current_year_taken,
            color: "#33A3F4",
        },
    ];
    const datamedical = [
        { title: "One", value: count?.medical_leave_balance, color: "#A3AED0" },
        {
            title: "Two",
            value: count?.medical_leave_current_year_taken,
            color: "#33A3F4",
        },
    ];
    const dataextraleave = [
        {
            title: "One",
            value: "",
            color: "#A3AED0",
        },
        {
            title: "Two",
            value: count?.extra_ordinary_leave_current_year_taken,
            color: "#33A3F4",
        },
    ];
    const dataresholiday = [
        {
            title: "One",
            value: count?.restricted_holiday_balance,
            color: "#A3AED0",
        },
        {
            title: "Two",
            value: count?.restricted_holiday_current_year_taken,
            color: "#33A3F4",
        },
    ];
    const datacamp = [
        { title: "One", value: count?.comp_off_balance, color: "#A3AED0" },
        {
            title: "Two",
            value: count?.comp_off_current_year_taken,
            color: "#33A3F4",
        },
    ];
    const dataspecial = [
        {
            title: "One",
            value: count?.special_casual_leave_balance,
            color: "#A3AED0",
        },
        {
            title: "Two",
            value: count?.special_casual_leave_current_year_taken,
            color: "#33A3F4",
        },
    ];
    const getLeaveData = async () => {
        const response = await AdminEmployeeLeaveInfo(id, token)
        if (response && response?.statusCode === 200) {
            setCount(response?.data)
        }
    }

    useEffect(() => {
        getLeaveData()
    },[])
    return (
        // <div className='row gx-4 mt-4'>
        //     {arr.map((item) => (
        //         <div className="col-lg-4 d-flex">
        //             <div className="timebox11">
        //                 <div className="row">
        //                     <div className="col-lg-4">
        //                         <PieChart
        //                             data={datacamp}
        //                             lineWidth={30}
        //                             labelPosition={0}
        //                             startAngle={90}
        //                         />
        //                     </div>
        //                     <div className="col-lg-8">
        //                         <div className="mt-3">
        //                             <h6 className="leavetitle1">Comp Off</h6>
        //                             <h6 className="leavesubtitle11">
        //                                 <span className="dot1"></span>
        //                                 &nbsp;Remaining -{" "}
        //                                 {/* {count?.comp_off_balance} */}
        //                             </h6>
        //                             <h6 className="leavesubtitle11">
        //                                 <span className="dot2"></span>{" "}
        //                                 &nbsp;Used -{" "}
        //                                 {/* {count?.comp_off_current_year_taken} */}
        //                             </h6>
        //                             <h6 className="leavesubtitle11">
        //                                 <span className="dot3"></span>{" "}
        //                                 &nbsp;Total -{" "}
        //                                 {/* {count?.comp_off_total_days} */}
        //                             </h6>
        //                         </div>
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     ))}
        // </div>
        <>
            <div className="row ">
                <div className="col-lg-12">
                    <div className="row">
                        <div className="col-lg-4 d-flex">
                            <div className="timebox1">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <PieChart
                                            data={datacasual}
                                            lineWidth={30}
                                            labelPosition={0}
                                            startAngle={130}
                                        />
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="mt-3">
                                            <h6 className="leavetitle">
                                                Casual Leave
                                            </h6>
                                            <h6 className="leavesubtitle1">
                                                <span className="dot1"></span>
                                                &nbsp;Remaining - &nbsp;
                                                {count?.casual_leave_balance}
                                            </h6>
                                            <h6 className="leavesubtitle1">
                                                <span className="dot2"></span>{" "}
                                                &nbsp;Used -{" "}
                                                {count?.casual_leave_current_year_taken}
                                            </h6>
                                            <h6 className="leavesubtitle1">
                                                <span className="dot3"></span>{" "}
                                                &nbsp;Total -&nbsp;
                                                {count?.casual_leave_total_days}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 d-flex">
                            <div className="timebox1">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <PieChart
                                            data={dataearned}
                                            lineWidth={30}
                                            labelPosition={0}
                                            startAngle={90}
                                        />
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="mt-3">
                                            <h6 className="leavetitle">
                                                Earned Leave
                                            </h6>
                                            <h6 className="leavesubtitle1">
                                                <span className="dot1"></span>
                                                &nbsp;Remaining -&nbsp;
                                                {count?.earned_leave_balance}
                                            </h6>
                                            <h6 className="leavesubtitle1">
                                                <span className="dot2"></span>{" "}
                                                &nbsp;Used -&nbsp;
                                                {count?.earned_leave_current_year_taken}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 d-flex">
                            <div className="timebox1">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <PieChart
                                            data={datamedical}
                                            lineWidth={30}
                                            labelPosition={0}
                                            startAngle={90}
                                        />
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="mt-3">
                                            <h6 className="leavetitle">
                                                Half Pay Leave(HPL)
                                            </h6>
                                            <h6 className="leavesubtitle1">
                                                <span className="dot1"></span>
                                                &nbsp;Remaining -{" "}
                                                {count?.medical_leave_balance}
                                            </h6>
                                            <h6 className="leavesubtitle1">
                                                <span className="dot2"></span>{" "}
                                                &nbsp;Used -{" "}
                                                {
                                                    count?.medical_leave_current_year_taken
                                                }
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-lg-4 d-flex">
                            <div className="timebox1">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <PieChart
                                            data={dataresholiday}
                                            lineWidth={30}
                                            labelPosition={0}
                                            startAngle={90}
                                        />
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="mt-3">
                                            <h6 className="leavetitle">
                                                Restricted Holidays
                                            </h6>
                                            <h6 className="leavesubtitle1">
                                                <span className="dot1"></span>{" "}
                                                &nbsp;Remaining -{" "}
                                                {count?.restricted_holiday_balance}
                                            </h6>
                                            <h6 className="leavesubtitle1">
                                                <span className="dot2"></span>{" "}
                                                &nbsp;Used -{" "}
                                                {
                                                    count?.restricted_holiday_current_year_taken
                                                }
                                            </h6>
                                            <h6 className="leavesubtitle1">
                                                <span className="dot3"></span>{" "}
                                                &nbsp;Total -{" "}
                                                {count?.restricted_holiday_total_days}
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {profile?.profile === 'group_a_officer' ? '' : profile?.profile === "supporting_staff" ? (
                            <div className="col-lg-4 d-flex">
                                <div className="timebox1">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <PieChart
                                                data={datacamp}
                                                lineWidth={30}
                                                labelPosition={0}
                                                startAngle={90}
                                            />
                                        </div>
                                        <div className="col-lg-8">
                                            <div className="mt-3">
                                                <h6 className="leavetitle">Comp Off</h6>
                                                <h6 className="leavesubtitle1">
                                                    <span className="dot1"></span>
                                                    &nbsp;Remaining -{" "}
                                                    {count?.comp_off_balance}
                                                </h6>
                                                <h6 className="leavesubtitle1">
                                                    <span className="dot2"></span>{" "}
                                                    &nbsp;Used -{" "}
                                                    {count?.comp_off_current_year_taken}
                                                </h6>
                                                <h6 className="leavesubtitle1">
                                                    <span className="dot3"></span>{" "}
                                                    &nbsp;Total -{" "}
                                                    {count?.comp_off_total_days}
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="col-lg-4 d-flex">
                                <div className="timebox1">
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <PieChart
                                                data={dataspecial}
                                                lineWidth={30}
                                                labelPosition={0}
                                                startAngle={90}
                                            />
                                        </div>
                                        <div className="col-lg-8">
                                            <div className="mt-3">
                                                <h6 className="leavetitle">
                                                    Special Casual Leave
                                                </h6>
                                                <h6 className="leavesubtitle1">
                                                    <span className="dot1"></span>
                                                    &nbsp;Remaining -{" "}
                                                    {count?.special_casual_leave_balance}
                                                </h6>
                                                <h6 className="leavesubtitle1">
                                                    <span className="dot2"></span>{" "}
                                                    &nbsp;Used -{" "}
                                                    {
                                                        count?.special_casual_leave_current_year_taken
                                                    }
                                                </h6>
                                                <h6 className="leavesubtitle1">
                                                    <span className="dot3"></span>{" "}
                                                    &nbsp;Total -{" "}
                                                    {
                                                        count?.special_casual_leave_total_days
                                                    }
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="col-lg-4 d-flex">
                            <div className="timebox1">
                                <div className="row">
                                    <div className="col-lg-4">
                                        <PieChart
                                            data={dataextraleave}
                                            lineWidth={30}
                                            labelPosition={0}
                                            startAngle={90}
                                        />
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="mt-3">
                                            <h6 className="leavetitle">
                                                Extra Ordinary Leave
                                            </h6>
                                            <h6 className="leavesubtitle1">
                                                <span className="dot2"></span>{" "}
                                                &nbsp;Used -&nbsp;
                                                {
                                                    count?.extra_ordinary_leave_current_year_taken
                                                }
                                            </h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LeaveInfo